import React, { Component, useState } from 'react';
import { useSelector } from 'react-redux';
import axios from 'axios';
import ChangePwModal from './ChangePwModal';

const Header = ({}) => {
  const [showModal, setShowModal] = useState(false);
  const user = useSelector((state) => state.app.user);
  const handleLogout = (e) => {
    e.preventDefault();
    axios.get('/api/v1/logout').then(({ data }) => {
      if (data.success) {
        window.location.href = '/';
      }
    });
  };

  const handleChangePw = (e) => {
    setShowModal(true);
  };
  return (
    <header>
      {showModal && <ChangePwModal handleClose={() => setShowModal(false)} />}
      <nav class='navbar navbar-expand-lg navbar-light fixed w-full horizontal-nav'>
        <div class='container py-2'>
          <div class='flex items-center justify-between'>
            <a class='navbar-brand' href='/'>
              <img
                src='/logo.jpg'
                class='mr-2 w-[130px]'
                alt='logo'
                style={{ width: 180 }}
              />
            </a>
            <button class='navbar-toggler hidden text-end mobile-menu-button'>
              <span class='navbar-toggler-icon'>
                <i class='ti-menu icon-align-right'></i>
              </span>
            </button>
            <div
              class='navbar-collapse flex-1 mobile-menu hidden min-[991px]:block'
              id='navbarNav'
            >
              <ul class='navbar-nav justify-end horizontal-menu'>
                {user ? (
                  <>
                    {user?.personal === 0 && (
                      <li className='scroll dropdown active '>
                        <a href='/accounts' style={{ padding: '24px 15px ' }}>
                          {/* <span class='text-muted inline-block ml-2'> */}
                          Manage Accounts
                          {/* </span> */}
                        </a>
                      </li>
                    )}
                    <li className='scroll dropdown active group/menu'>
                      <a
                        href='javaScript:void();'
                        class='dropdown-toggle'
                        style={{ padding: '24px 15px ' }}
                      >
                        {/* <span class='text-muted inline-block ml-2'> */}
                        Welcome!, {user?.name}
                        {/* </span> */}
                      </a>
                      <ul
                        className='dropdown-menu hidden group-hover/menu:block'
                        style={{ top: 50 }}
                      >
                        <li>
                          <a href='#' onClick={handleChangePw}>
                            Change password
                          </a>
                        </li>
                        <li>
                          <a href='#' onClick={handleLogout}>
                            Logout
                          </a>
                        </li>
                      </ul>
                    </li>
                  </>
                ) : (
                  <a
                    class='btn btn-sm btn-custom navbar-btn btn-rounded'
                    href='/login'
                  >
                    Login
                  </a>
                )}
              </ul>
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
};
export default Header;
